import React from 'react'
import { styled, useTheme } from 'src/ui/theme'
import { Header, Body } from 'src/ui/typography'
import { HBox } from 'src/ui/layout'
import { BonusStep } from '../../molecules'
import { TBonusesStepData } from './types'
import { Icons } from 'src/ui/icons'
import { useDimensions, breakpoints } from 'src/ui/dimensions'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1312px;
  margin: 64px auto;

  @media (max-width: ${breakpoints.mobile}px) {
    width: calc(100% - 32px);
    margin: 24px auto 0;
  }
`

const Steps = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: ${breakpoints.mobile}px) {
    flex-direction: column;
  }
`

const SmallIconWrap = styled.div`
  width: 24px;
  height: 24px;
  margin: 105px 0 0;
`

type Props = {
  steps: TBonusesStepData[]
}

export const BonusSteps: React.FC<Props> = ({ steps }) => {
  const theme = useTheme()
  const { isMobile } = useDimensions()

  const titleFontSize = isMobile ? 'h4' : 'h2'

  return (
    <Wrapper>
      <Header size={titleFontSize}>Как получить бонус?</Header>
      <HBox height={isMobile ? 8 : 24} />

      {isMobile ? (
        <Body>Четыре простых шага:</Body>
      ) : (
        <Header size="h4" color={theme.colors.black.secondary}>
          Четыре простых шага:
        </Header>
      )}

      <HBox height={isMobile ? 32 : 64} />
      <Steps>
        {steps.map((step, index) => {
          const isLast = index + 1 === steps.length

          return (
            <React.Fragment key={index}>
              <BonusStep
                icon={step.icon}
                title={step.title}
                subtitle={step.subtitle}
              />
              {!isLast && !isMobile && (
                <SmallIconWrap>
                  <Icons.FullRightArrow />
                </SmallIconWrap>
              )}
            </React.Fragment>
          )
        })}
      </Steps>
    </Wrapper>
  )
}
